import { ContactEmployeePicker } from '@/modules/internal-v2/shared/contact-employee-picker.component';

interface PreviewRecipientPickerProps {
  /** Currently picked contact-employee id; `null` when no recipient is selected. */
  value: number | null;
  onChange: (next: number | null) => void;
}

/**
 * Compact typeahead for the "Vorschau-Empfänger" — picks a contact employee
 * whose `gender` + `salutation` (and business partner name) drive the live
 * preview's variable resolution.
 *
 * Thin wrapper over the shared `ContactEmployeePicker` (single-select mode).
 * Kept as its own file because the picker has its own placement in the
 * preview-pane header and existing imports refer to it by name.
 *
 * No picker selection = no recipient context = the preview pane shows
 * unfilled `{{token}}` chips so the author can see the slots.
 */
export function PreviewRecipientPicker({
  value,
  onChange,
}: PreviewRecipientPickerProps) {
  return (
    <ContactEmployeePicker
      mode="single"
      label="Vorschau-Empfänger"
      value={value}
      onChange={onChange}
    />
  );
}
